export default {
  namespaced: true,

  state: () => ({
    giftProducts: {
      data: [],
      links: {},
      meta: {},
    },
    isLoading: false,
    isShowEditVariant: false,
  }),

  getters: {
  },

  mutations: {
    SET_GIFT_PRODUCTS(state, payload) {
      state.giftProducts = payload
    },
    SET_LOADING(state, value) {
      state.isLoading = value
    },
    SET_OPEN_EDIT(state, value) {
      state.isShowEditVariant = value
    },
  },

  actions: {
    async getGiftProducts({ commit, dispatch }, { page = null, keyword = '' } = {}) {
      try {
        commit('SET_LOADING', true)
        const url = '/v1/admin/gift-products/no-variant?sort=-payment_progress'

        const response = await this._vm.$http.get(url, {
          params: {
            page,
            'filter[keyword]': keyword,
          },
        })

        if (response.data.meta.current_page > response.data.meta.last_page && response.data.meta.total > 0) {
          dispatch('getGiftProducts', { page: response.data.meta.last_page, keyword })
          return null
        }

        commit('SET_GIFT_PRODUCTS', response.data)

        commit('SET_LOADING', false)
        return response.data
      } catch (error) {
        commit('SET_LOADING', false)
        return error
      }
    },
    async updateVariant({ commit, dispatch, state }, { skuId, alternativeSkuId, query }) {
      try {
        commit('SET_LOADING', true)
        const url = `v1/admin/gift-products/${skuId}`

        const response = await this._vm.$http.put(url, { sku_id: alternativeSkuId })
        commit('SET_LOADING', false)

        dispatch('getGiftProducts', { page: state.giftProducts.meta.current_page, keyword: query.keyword || '' })

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengubah URL Produk!',
        }, { root: true })

        commit('SET_OPEN_EDIT', false)

        return response.data.data
      } catch (error) {
        commit('SET_LOADING', false)
        commit('response/SET_ERROR', {
          message: 'Error!',
        }, { root: true })
        return error
      }
    },
  },
}
